const PrintIcon = (props) => {
    const { className } = props;
    return (<i className={"fa-solid fa-print " + className}></i>)
}

export default PrintIcon;